import { getRecipients } from './actions';
export const CLEAR_RECIPIENTS_ERROR = 'upload/clearRecipientsError';

export const reducer = (state = { recipients: [], hasRecipients: false }, action) => {
  switch (action.type) {
    case CLEAR_RECIPIENTS_ERROR:
      return {
        ...state,
        hasError: false,
        apiError: undefined,
      };
    case getRecipients.pending.type:
      return {
        ...state,
        isFetching: true,
      };
    case getRecipients.fulfilled.type:
      return {
        ...state,
        recipients: action.payload,
        isFetching: false,
        hasRecipients: true
      };
    case getRecipients.rejected.type:      
      return {
        ...state,
        isFetching: false,
        hasError: true,
        apiError: action.error
      };
    default:
      return state;
  }
};